'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.associateFileAttachmentsWithChannel = undefined;

var _q = require('q');

var _q2 = _interopRequireDefault(_q);

var _get = require('transmute/get');

var _get2 = _interopRequireDefault(_get);

var _threadGetters = require('conversations-schema/thread/operators/threadGetters');

var _getConversations = require('../../selectors/conversationSelectors/getConversations');

var _getSessionId = require('../../selectors/widgetDataSelectors/getSessionId');

var _fileIdsAreResolved = require('../../resolved-attachments/selectors/fileIdsAreResolved');

var _associateFileAttachmentsWithThread = require('./associateFileAttachmentsWithThread');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var associateFileAttachmentsWithChannel = exports.associateFileAttachmentsWithChannel = function associateFileAttachmentsWithChannel(_ref) {
  var attachments = _ref.attachments,
      channel = _ref.channel;
  return function (dispatch, getState) {
    var sessionId = (0, _getSessionId.getSessionId)(getState());
    var conversations = (0, _getConversations.getConversations)(getState());
    var thread = (0, _get2.default)(channel, conversations);
    var threadId = (0, _threadGetters.getThreadId)(thread);

    if (!attachments || !attachments.size) {
      return _q2.default.Promise.resolve();
    }

    var fileAttachment = attachments.first();
    var fileIds = (0, _get2.default)('fileIds', fileAttachment);

    if ((0, _fileIdsAreResolved.fileIdsAreResolved)(getState(), { thread: thread, fileIds: fileIds })) {
      return _q2.default.Promise.resolve();
    }

    return dispatch((0, _associateFileAttachmentsWithThread.associateFileAttachmentsWithThread)({
      fileIds: fileIds,
      sessionId: sessionId,
      threadId: threadId
    }));
  };
};


//////////////////
// WEBPACK FOOTER
// ./js/file-uploads/actions/associateFileAttachmentsWithChannel.js
// module id = 428
// module chunks = 2 3